export class UrlHandler {
  open(url: URL): void {
    window.location.href = url.href
  }
}
